import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../__partials/avatar';
import { marginClassNamePropType } from '../../__utils/spacingClassNamePropType';

const AvatarOrg = ({
  size,
  imageUrl,
  initials,
  primaryColor,
  secondaryColor,
  showOuterBorder,
  onMouseEnter,
  onMouseLeave,
  onClick,
  className,
  qaId,
}) => {
  return (
    <Avatar
      type="org"
      size={size}
      imageUrl={imageUrl}
      text={initials}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      showOuterBorder={showOuterBorder}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      className={className}
      qaId={qaId}
    />
  );
};

AvatarOrg.propTypes = {
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'profile']),
  imageUrl: PropTypes.string,
  initials: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  showOuterBorder: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  className: marginClassNamePropType,
  qaId: PropTypes.string,
};

AvatarOrg.defaultProps = {
  size: 'medium',
  className: '',
};

export default AvatarOrg;



// WEBPACK FOOTER //
// ./src/avatars/org/index.jsx